import { Link, NavLink } from "react-router-dom";
import { authClient } from "@/lib/auth";
import { Logo } from "./Logo";
import { Button } from "@/components/ui/button";
import { GithubLogo } from "@phosphor-icons/react";

export function Header() {
  const { data: session } = authClient.useSession();

  return (
    <header className="sticky top-0 z-40 border-b border-zinc-900/70 bg-[oklch(11%_0.012_70_/_0.78)] backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <Logo />
        <nav className="hidden items-center gap-1 md:flex">
          {[
            ["/effects", "Effects"],
            ["/try", "Try It"],
            ["/pricing", "Pricing"],
            ["/docs", "Docs"],
          ].map(([href, label]) => (
            <NavLink
              key={href}
              to={href!}
              className={({ isActive }) =>
                `rounded-md px-3 py-1.5 text-sm transition ${
                  isActive ? "text-accent-200" : "text-zinc-400 hover:text-zinc-100"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a
            href="https://github.com/herobg"
            className="rounded-md p-2 text-zinc-400 transition hover:text-zinc-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-400"
            aria-label="GitHub"
          >
            <GithubLogo className="h-4 w-4" weight="bold" />
          </a>
          {session?.user ? (
            <>
              <Link to="/dashboard">
                <Button variant="subtle" size="sm">Dashboard</Button>
              </Link>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => authClient.signOut().then(() => (location.href = "/"))}
              >
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Link to="/sign-in">
                <Button variant="ghost" size="sm">Sign in</Button>
              </Link>
              <Link to="/pricing">
                <Button size="sm">Buy $79</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
